import { adventureIslandManifest } from '@pixelworld/adventure-island/meta';
import type { ClientGameDefinition } from '@pixelworld/game-core/client';
import type { GameId } from '@pixelworld/shared';

/** Every game in the catalog. The game code (and Phaser) loads only when a game starts. */
export const clientGames: readonly ClientGameDefinition[] = [
  {
    ...adventureIslandManifest,
    load: () =>
      import('@pixelworld/adventure-island/client').then((module) => module.adventureIslandClient),
    loadAvatarArt: () =>
      import('@pixelworld/adventure-island/avatar').then(
        (module) => module.adventureIslandAvatarArt,
      ),
  },
];

export function findClientGame(id: GameId | undefined): ClientGameDefinition | undefined {
  return clientGames.find((game) => game.id === id);
}
